module.exports = __webpack_public_path__ + "img/item1.b69c43a0.png";